import React, { Component, Suspense } from "react";
import { withStorage } from "../Utils/Utils";
import { withRemote } from "../Utils/Utils";
import { withData } from "../DataController";
import { CloudOff, Folder, Edit2, Video } from "react-feather";
import Page from "../Page";
import Modal from "../components/Modals/Modal";
import EditorSideBarExtension from "../components/SideBar/SideBarExtension/EditorSideBarExtension";
import ExternalManagerEditorSideBarExtension from "../components/SideBar/SideBarExtension/ExternalManagerEditorSideBarExtension";
import AlertBlock from "./Shared/Prompts/AlertBlock";
import AlertBanner from "./Shared/Prompts/AlertBanner";
import LoadingOverlay from "./LoadingOverlay";
import SideBarRight from "../components/SideBar/SideBarRight";
import CommentsSidebarExtension from "../components/SideBar/SideBarExtension/CommentsSidebarExtension";
import OptionsSidebarExtension from "../components/SideBar/SideBarExtension/OptionsSidebarExtension";
import DataSidebarExtension from "../components/SideBar/SideBarExtension/DataSidebarExtension";
import VersionsSidebarExtension from "../components/SideBar/SideBarExtension/VersionsSidebarExtension";
import NotesSidebarExtension from "../components/SideBar/SideBarExtension/NotesSidebarExtension"
import LoadingIcon from "../components/LoadingIcon";
import VideoUploadPanel from "./VideoUploadPanel";
import { comparePath, compareTickerKey } from "./ComparePage/versionApi";
import "./BuilderPage.scss";

class BuilderPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pdf: null,
			errors: {},
			tickerPreviewed: false,
			isLoading: false,
			showingPdf: 2,
			pdf1: null,
			pdf2: null,
			template: null,
			//Do not camel case these, they are derived
			showuploadFailure: false,
			badProforma: false,
			showanalystChecklist: false,
			saveError: false,
			sideBarExtRight: "",
			commentsSlideIn: true,
			commentsSlideOut: false,
			compliance: {
				requested: false,
				approved: false,
				denied: false,
				comment: false
			},
			peerReview: {
				requested: false,
				approved: false,
				denied: false,
				comment: false
			},
			optionalPages: [],
			loadingLocalData: false,
			elementsWithSupercript: [],
			locatedFootnote: null,
			leftSideBarCollapsed: false,
			replaceFootNoteWarning: false,
			showTemplatePlaceholder: false,
			lockedEditor: false,
			selectedPortfolioMode: 'editor',
			selectedPortfolioTicker: null,
			selectedGroupStatus: null,
			selectedReadyLock: false,
			hasCompareTargets: false
		};
		this.onPreview = this.onPreview.bind(this);
		this.tickerPreview = this.tickerPreview.bind(this);
		this.downloadPDF = this.downloadPDF.bind(this);
		this.onTemplateChange = this.onTemplateChange.bind(this);
		this.showModal = this.showModal.bind(this);
		this.cancelModal = this.cancelModal.bind(this);
		this.confirmModal = this.confirmModal.bind(this);
		this.modalConfirmCallbacks = {};
		this.modalCancelCallbacks = {};
		this.modalData = {};
		this.showSaveError = this.showSaveError.bind(this);
		this.hideSaveError = this.hideSaveError.bind(this);
		this.setSideBarExtRight = this.setSideBarExtRight.bind(this)
	}


	showModal(name, confirmCallback, cancelCallback, data) {
		this.modalConfirmCallbacks[name] = confirmCallback;
		this.modalCancelCallbacks[name] = cancelCallback;
		this.modalData[name] = data;
		this.setState({ ["show" + name]: true });
	}

	showSaveError() {
		// this.setState({ saveError: true });
		// this.props.storage.put("research-master-grid", "alertBannerActive");
	}

	hideSaveError() {
		// this.setState({ saveError: false });
		// this.props.storage.put("research-master-grid", "alertBannerInactive");
	}

	cancelModal(name) {
		this.setState({ ["show" + name]: false });
		if (this.modalCancelCallbacks[name])
			this.modalCancelCallbacks[name]();

		this.modalCancelCallbacks[name] = null;
		this.modalConfirmCallbacks[name] = null;
	}

	confirmModal(name) {
		this.setState({ ["show" + name]: false });
		if (this.modalConfirmCallbacks[name])
			this.modalConfirmCallbacks[name]();

		this.modalCancelCallbacks[name] = null;
		this.modalConfirmCallbacks[name] = null;
	}

onPreview(dto) {
		this.setState({ isLoading: true }, () =>
			this.props.remote
				.post("/preview", dto)
				.then(previewResponse => {
					this.setState({ errors: {} }, () => {
						//TODO
						/*let {pdf, ...others} = previewResponse;
						let newState = {
							...others,
							tickerPreviewed: true
						};
						if (this.state.showingPdf === 2)
						newState.pdf1 = pdf;
						else
						newState.pdf2 = pdf;
						this.setState(newState, () => setTimeout(() => this.setState({ isLoading: false, showingPdf: this.state.showingPdf === 1 ? 2 : 1 }), 1000))
						*/
					});
				})
		);
	}

	tickerPreview(dto, callback) {
		this.setState({ isLoading: true });
		this.props.remote.post("/ticker", dto)
			.then(response => {
				//const previewResponse = response.pdf;
				this.setState({ errors: {} }, () => {

					/*
					let {pdf, ...others} = previewResponse;
					let newState = {
						...others,
						tickerPreviewed: true
					};
					if (this.state.showingPdf === 2)
					newState.pdf1 = pdf;
					else
					newState.pdf2 = pdf;
					this.setState(newState, () => setTimeout(() => this.setState({ isLoading: false, showingPdf: this.state.showingPdf === 1 ? 2 : 1 }), 1000))
					*/
					//TODO
				});
				if (callback)
					callback(response);
			});
	}

	onTemplateChange(template) {
		//console.log("Builder page getting template change")
		const pinnableElementsArray = template.pages.flatMap(page => page.content.filter(element => element.className === 'FootNoteableFixedLabel'))
		this.setState({ template, elementsWithSupercript: pinnableElementsArray });
	}

	downloadPDF(dto, callback, completedCallback) {
		dto = dto || {};
		//dto.template = JSON.stringify(this.props.template);
		dto.data = {};
		this.props.data.compileData(dto.data);

		if (callback) {
			callback(dto);
		} else {
			const ticker = dto.tickerGroup ? dto.tickerGroup : dto.tickers[0];
			const filename = this.props.data.getValue(this.state.template.title) + ".pdf";

			this.props.remote
				.post("/previewv2/" + ticker + "/" + dto.template, dto)
				.then(previewResponse => {
					const url = "data:application/pdf;base64, " + previewResponse.pdf;

					// use HTML5 a[download] attribute to specify filename
					const a = document.createElement("a");
					// safari doesn't support this yet
					if (typeof a.download === 'undefined') {
						window.location = url;
					} else {
						a.href = url;
						a.download = filename;
						document.body.appendChild(a);
						a.click();
					}
					if (completedCallback) {
						completedCallback();
					}
				}).catch(error => {
					console.log(error)
					if (completedCallback) {
						completedCallback();
					}
				});
		}
	}


	// Compare Documents rail entry (RES-561): the route for the loaded document, or
	// null before a document is selected.
	getComparePath() {
		const tickerKey = compareTickerKey(this.props.data);
		const templateName = this.props.data && this.props.data.templateName;
		return tickerKey && templateName ? comparePath(tickerKey, templateName) : null;
	}

	// The Compare link only lights up once the document has something to compare
	// against (≥1 saved version — publishing always locks a version row). Re-checked
	// whenever the loaded document changes.
	componentDidMount() {
		this.refreshCompareTargets();
	}

	componentDidUpdate() {
		this.refreshCompareTargets();
	}

	refreshCompareTargets() {
		const link = this.getComparePath();
		if (link === this.lastComparePath)
			return;
		this.lastComparePath = link;
		this.setState({ hasCompareTargets: false });
		if (!link)
			return;
		this.props.data.getVersions(1).then(v => {
			if (this.lastComparePath === link)
				this.setState({ hasCompareTargets: !!(v && v.success && v.data && v.data.length) });
		});
	}

	setSideBarExtRight(content, canClose) {

		if (this.state.sideBarExtRight === content && canClose) {

			this.setState({ commentsSlideIn: false })
			setTimeout(() => { this.setState({ commentsSlideOut: true }) }, 10)

			setTimeout(() => {
				this.setState({ sideBarExtRight: "" })
				this.props.storage.put("research-master-grid", "sideBarExtRightInactive")
			}, 250)
		} else if (this.state.sideBarExtRight !== content) {
			this.setState({ sideBarExtRight: content, commentsSlideIn: true, commentsSlideOut: false })
			this.props.storage.put("research-master-grid", "sideBarExtRightActive")
		}
	}


	render() {
		const { template } = this.state;

		let output = template && template.outputs && template.outputs.filter(o => o.dflt)
		let outputName = output && output[0] && output[0].key;
		let ComplianceModal;
		try {
			ComplianceModal = React.lazy(() => import(`./CompanyUserManagement/${this.props.organisation.peerChecklistComponent}`));
		} catch (error) {
			console.log(error);
			ComplianceModal = <div>An error occurred.  This may be caused by corruption in your browser.  Please clear any caches and reload the page</div>
		}
		// const ComplianceModal = React.lazy(() => import('./CompanyUserManagement/Hobson/PeerComplianceModal'));
		// const ComplianceModal = React.lazy(() => import('./CompanyUserManagement/Hobson/PeerComplianceModal'));


		return (
			<>
				{/* Checklist Modal */}
				{this.state.showanalystChecklist &&
					<Modal
						alignModal="top"
						header="Responsible Analyst Checklist and Declaration"
						cancelButton={{ onClick: () => this.cancelModal("analystChecklist") }}
						confirmButton={{ onClick: () => this.confirmModal("analystChecklist") }}
						handleClose={() => this.cancelModal("analystChecklist")}
					>
						<Suspense fallback={<div>Loading...</div>}>
							<ComplianceModal />
						</Suspense>

					</Modal>
				}
				{this.state.saveError &&
					<AlertBanner type="danger" icon={<CloudOff />}>
						There was an error saving your changes.  Either you have lost your internet connection or our server is temporarily offline.
					</AlertBanner>
				}
				{this.state.showuploadFailure && <Modal
					header="Upload Failed"
					confirmButton={{ onClick: () => this.cancelModal("uploadFailure") }}
					handleClose={() => this.cancelModal("uploadFailure")}>
					<AlertBlock type="danger">File uploaded, but was not able to be parsed.  Is the file the correct proforma format?</AlertBlock>
				</Modal>}
				{this.state.showbadProforma && <Modal
					header="Upload Failed"
					confirmButton={{ onClick: () => this.cancelModal("badProforma") }}
					handleClose={() => this.cancelModal("badProforma")}>
					{/* <p className="mb-s">Failed to upload proforma.</p> */}
					{this.modalData.badProforma.tooBig && this.modalData.badProforma.tooBig.length > 0 && this.modalData.badProforma.tooBig.map(file => <AlertBlock header large type="danger" fullWidth>Maximum file size exceeded: {file.name}</AlertBlock>)}
					{this.modalData.badProforma.wrongFileType && this.modalData.badProforma.wrongFileType.length > 0 && this.modalData.badProforma.wrongFileType.map(file => <AlertBlock header large type="danger" fullWidth>File not recognised as a .xlsx: {file.name}</AlertBlock>)}
				</Modal>}
				{this.state.showpublishConfirm && <Modal
					header="Confirm Publish"
					cancelButton={{ onClick: () => this.cancelModal("publishConfirm") }}
					confirmButton={{ onClick: () => this.confirmModal("publishConfirm") }}
					handleClose={() => this.cancelModal("publishConfirm")}>
					<p>Are you sure you wish to publish?</p>
				</Modal>}
				{this.state.showoverrideConfirm && <Modal
					header="Confirm Review Bypass"
					cancelButton={{ onClick: () => this.cancelModal("overrideConfirm") }}
					confirmButton={{ onClick: () => this.confirmModal("overrideConfirm") }}
					handleClose={() => this.cancelModal("overrideConfirm")}>
					<AlertBlock header large type="warning">Note will be published without Compliance and/or Peer review. Compliance will be notified. Are you sure?</AlertBlock>
				</Modal>}
				{this.state.showpublishFailure && <Modal
					header="Publish Failed"
					confirmButton={{ onClick: () => this.confirmModal("publishFailure") }}
					handleClose={() => this.confirmModal("publishFailure")}>
					<AlertBlock className="publish-failure-alert" large type="danger">
						{this.modalData["publishFailure"].message}

						{this.modalData["publishFailure"].data &&
							<ul className="publish-failure-list">
								{this.modalData["publishFailure"].data.map((reason, idx) => {
									return <li className="publish-failure-list-item" key={"failureModalReason-" + idx}>{reason}</li>
								})}
							</ul>
						}
					</AlertBlock>
				</Modal>}
				{this.state.showreviewFailure && <Modal
					header="Review Request Failed"
					confirmButton={{ onClick: () => this.confirmModal("reviewFailure") }}
					handleClose={() => this.confirmModal("reviewFailure")}>
					<p>{(this.modalData["reviewFailure"] && this.modalData["reviewFailure"].message) || "We're sorry, something went wrong.  Please contact 3Skye"}</p>
				</Modal>}
				{this.state.showreviewResent && <Modal
					header="Review Request Resent"
					confirmButton={{ onClick: () => this.confirmModal("reviewResent") }}
					handleClose={() => this.confirmModal("reviewResent")}>
					<p>{(this.modalData["reviewResent"] && this.modalData["reviewResent"].message)}</p>
				</Modal>}
				{this.state.showpublishSuccess && <Modal
					header="Publish Successful"
					confirmButton={{ onClick: () => this.confirmModal("publishSuccess") }}
					handleClose={() => this.confirmModal("publishSuccess")}>
					<p>Note successfully published</p>
				</Modal>}
				{/*<SideBar onPreview={this.onPreview} tickerPreview={this.tickerPreview} errors={this.state.errors} downloadPDF={this.downloadPDF}/>*/}
				{this.props.isExternalManager
					? <ExternalManagerEditorSideBarExtension
						downloadPDF={this.downloadPDF}
						onTemplateChange={this.onTemplateChange}
						collapsable showModal={this.showModal}
						showSaveError={this.showSaveError}
						hideSaveError={this.hideSaveError}
						setCompliance={(compliance, callback) => this.setState({ compliance }, callback && callback)}
						setPeerReview={(peerReview, callback) => this.setState({ peerReview }, callback && callback)}
						compliance={this.state.compliance}
						peerReview={this.state.peerReview}
						setSideBarExtRight={this.setSideBarExtRight}
						optionalPages={this.state.optionalPages}
						setOptionalPages={(optionalPages, callback) => { this.setState({ optionalPages }, callback && callback) }}
						loadingLocalData={this.state.loadingLocalData}
						setLoadingLocalData={(loadingLocalData, callback) => this.setState({ loadingLocalData }, callback && callback)}
						organisation={this.props.organisation}
						leftSideBarCollapsed={this.state.leftSideBarCollapsed}
						setLeftSideBarCollapsed={(boolean) => this.setState({ leftSideBarCollapsed: boolean })}
						setShowPlaceholder={(boolean) => this.setState({ showTemplatePlaceholder: boolean })}
						setPortfoliosState={(arr) => this.setState({ portfoliosState: arr })}
						setPortfoliosGroupedState={(arr) => this.setState({ portfoliosGroupedState: arr })}
						setCurrentFundNumber={(s) => this.setState({ currentFundNumber: s })}
						setPasteGroupings={(arr) => this.setState({ pasteGroupings: arr })}
						setAllFunds={(arr) => this.setState({ allFunds: arr })}
						uneditable={this.state.lockedEditor}
						setUneditable={(val) => this.setState({ lockedEditor: val })}
						setSelectedPortfolioMode={(opts) => {
							// Options-object API: { mode, fundNumber, name, members, status, isMemberPreview, linked }
							// All fields optional. `linked` defaults to true (Linked unless explicitly false);
							// `isMemberPreview` defaults to false. Callers without group context can omit
							// members/status/isMemberPreview/linked entirely.
							const { mode, fundNumber, name, members, status, isMemberPreview, linked } = opts || {};
							const isLinked = linked !== false;
							const readyLock = status === 'ready';
							this.setState({
								selectedPortfolioMode: mode,
								selectedPortfolioTicker: fundNumber,
								selectedPortfolioName: name,
								selectedGroupPortfolios: members || null,
								selectedGroupStatus: status || null,
								isGroupMemberPreview: isMemberPreview || false,
								selectedGroupLinked: isLinked,
								selectedReadyLock: readyLock,
							});
							// Push linked-group context into DataController so updateLocalData fans out via /savev2-bulk
							if (this.props.data && typeof this.props.data.setLinkedGroupContext === 'function') {
								const fundNumbers = (members || []).map(p => p && p.fundNumber).filter(Boolean);
								const useLinked = isLinked && !isMemberPreview && fundNumbers.length > 1;
								this.props.data.setLinkedGroupContext(useLinked ? { fundNumbers, linked: true } : null);
							}
						}}
						exposeMoveToReady={(fn) => { this.movePortfolioToReady = fn; }}
						exposeSetMode={(fn) => { this.setCurrentPortfolioMode = fn; }}
						onGroupsChange={(groups) => this.setState({ portfolioGroups: groups })}
					/>
					: <EditorSideBarExtension
						downloadPDF={this.downloadPDF}
						onTemplateChange={this.onTemplateChange}
						collapsable showModal={this.showModal}
						showSaveError={this.showSaveError}
						hideSaveError={this.hideSaveError}
						setCompliance={(compliance, callback) => this.setState({ compliance }, callback && callback)}
						setPeerReview={(peerReview, callback) => this.setState({ peerReview }, callback && callback)}
						compliance={this.state.compliance}
						peerReview={this.state.peerReview}
						setSideBarExtRight={this.setSideBarExtRight}
						optionalPages={this.state.optionalPages}
						setOptionalPages={(optionalPages, callback) => { this.setState({ optionalPages }, callback && callback) }}
						loadingLocalData={this.state.loadingLocalData}
						setLoadingLocalData={(loadingLocalData, callback) => this.setState({ loadingLocalData }, callback && callback)}
						organisation={this.props.organisation}
						leftSideBarCollapsed={this.state.leftSideBarCollapsed}
						setLeftSideBarCollapsed={(boolean) => this.setState({ leftSideBarCollapsed: boolean })}
						setShowPlaceholder={(boolean) => this.setState({ showTemplatePlaceholder: boolean })}
						setPortfoliosState={(arr) => this.setState({ portfoliosState: arr })}
						setCurrentFundNumber={(s) => this.setState({ currentFundNumber: s })}
						setPasteGroupings={(arr) => this.setState({ pasteGroupings: arr })}
						setAllFunds={(arr) => this.setState({ allFunds: arr })}
					/>}
				{/* <StandardSideBar onTemplateChange={this.onTemplateChange} collapsable/> */}
				<div className="editor-page-content" id="builder-page-page-wrapper" style={{ paddingLeft: 60 }}> {/* TODO: Put a prop or somthing in the template configuration*/}
					{this.props.isExternalManager && this.state.selectedGroupPortfolios && this.state.selectedPortfolioName && (
						<div className={`group-context-header${this.state.isGroupMemberPreview ? ' group-context-header--preview' : ''}`}>
							<Folder size={15} className="group-context-icon" />
							<span className="group-context-name">{this.state.selectedPortfolioName}</span>
							<span className={`group-context-badge${this.state.selectedGroupStatus === 'ready' ? ' group-context-badge--ready' : ''}`}>
								{this.state.selectedGroupStatus === 'ready' ? 'READY TO PUBLISH' : 'PENDING'}
							</span>
							<span className="group-context-divider" aria-hidden="true" />
							{this.state.isGroupMemberPreview ? (
								<span className="group-context-desc">Previewing individual portfolio</span>
							) : (
								<span className="group-context-desc">
									Editing <strong>{this.state.selectedGroupPortfolios.length} portfolio{this.state.selectedGroupPortfolios.length !== 1 ? 's' : ''}</strong> in {this.state.selectedPortfolioMode === 'video' ? 'Video' : 'Editor'} mode
								</span>
							)}
						</div>
					)}
					{/* group-preview-lock disabled — users can freely edit individual members
					{this.props.isExternalManager && this.state.isGroupMemberPreview && (
						<div className="group-preview-lock">
							<div className="group-preview-lock-inner">
								<Folder size={20} className="group-preview-lock-icon" />
								<span>Previewing only — select the group to edit all portfolios together</span>
							</div>
						</div>
					)}
					*/}
					{this.props.isExternalManager && this.state.selectedPortfolioMode === 'video' && this.state.selectedPortfolioTicker &&
						<VideoUploadPanel
							fundNumber={this.state.selectedPortfolioTicker}
							fundName={this.state.selectedPortfolioName}
							template={this.state.template?.name}
							templateObj={this.state.template}
							data={this.props.data}
							onMarkAsReady={() => {
								const targets = this.state.selectedGroupPortfolios
									|| [(this.state.portfoliosState || []).find(p => p.fundNumber === this.state.selectedPortfolioTicker)].filter(Boolean);
								targets.forEach(p => { if (this.movePortfolioToReady) this.movePortfolioToReady(p); });
								// No forced editor switch — moveToReady → setSelectedPortfolioMode already updates
								// mode/status/readyLock, mirroring the grouping-panel "Move to Ready" button.
							}}
							portfoliosState={this.state.portfoliosState}
							groupPortfolios={this.state.selectedGroupPortfolios}
							groups={this.state.portfolioGroups || []}
							uneditable={this.state.lockedEditor || this.state.selectedReadyLock}
						/>
					}
					{!this.state.showTemplatePlaceholder && this.state.template && !(this.props.isExternalManager && this.state.selectedPortfolioMode === 'video') && this.state.template.pages.map((page, idx) => {
						return (
							<Page
								template={this.state.template}
								elementsWithSupercript={this.state.elementsWithSupercript}
								locatedFootnote={this.state.locatedFootnote}
								unsetLocatedFootnote={() => this.setState({ locatedFootnote: null })}
								output={outputName} page={page}
								key={this.state.template.name + idx}
								pinSelected={this.state.pinSelected}
								portfoliosState={this.state.portfoliosState}
								portfoliosGroupedState={this.state.portfoliosGroupedState}
								currentFundNumber={this.state.currentFundNumber}
								pasteGroupings={this.state.pasteGroupings}
								allFunds={this.state.allFunds}
								selectedTemplate={this.state.selectedTemplate}
								uneditable={this.props.isExternalManager ? (this.state.lockedEditor || this.state.selectedReadyLock) : null}
							/>
						)
					})}
					{!this.state.replaceFootNoteWarning && this.state.showPinModal &&
						<div className='pinning-modal' style={{ right: this.state.leftSideBarCollapsed ? '9.5rem' : 0 }}>
							<div className='pinning-message-block'>
								<p>Select element to pin note</p>
								<p>Press esc key to cancel</p>
							</div>
						</div>
					}
					{this.state.loadingLocalData &&
						<div className='loading-modal' style={{ left: this.state.leftSideBarCollapsed ? 0 : '9.5rem' }}>
							<div className='loading-modal-inner'>
								<LoadingIcon variant='light' />
							</div>
						</div>
					}
					{this.state.isLoading && <LoadingOverlay variant='light' />}
				</div>
				{/* <SideBarRight setSideBarExtRight={this.setSideBarExtRight} /> */}
				<SideBarRight setSideBarExtRight={this.setSideBarExtRight} sideBarExtRight={this.state.sideBarExtRight} isExternalManager={this.props.isExternalManager} compareLink={this.state.hasCompareTargets ? this.getComparePath() : null} />
				{this.state.sideBarExtRight === "Data" &&
					<DataSidebarExtension
						consensusFields={this.props.data.consensusFields}
						contentData={this.props.data.contentData}
						slideIn={this.state.commentsSlideIn}
						slideOut={this.state.commentsSlideOut}
					/>}
				{this.state.sideBarExtRight === "Comments" &&
					<CommentsSidebarExtension
						slideIn={this.state.commentsSlideIn}
						slideOut={this.state.commentsSlideOut}
						compliance={this.state.compliance}
						peerReview={this.state.peerReview}
						data={this.props.data && (this.props.data.tickerGroup || (this.props.data.tickers && this.props.data.tickers[0] && this.props.data.tickers[0] !== "")) ? { type: this.props.data.templateName, ticker: this.props.data.templateType === 'fund' ? this.props.data.tickers[0] : this.props.data.tickerGroup ? this.props.data.tickerGroup : this.props.data.tickers[0] } : null}
					/>}
				{this.state.sideBarExtRight === "Options" &&
					<OptionsSidebarExtension
						loadingLocalData={this.state.loadingLocalData}
						setLoadingLocalData={(loadingLocalData, callback) => this.setState({ loadingLocalData }, callback && callback)}
						optionalPages={this.state.optionalPages}
						setOptionalPages={(optionalPages, callback) => { this.setState({ optionalPages }, callback && callback) }}
						slideIn={this.state.commentsSlideIn}
						slideOut={this.state.commentsSlideOut}
						template={this.state.template}
						tickers={this.props.data.tickers}
					/>}
				{this.state.sideBarExtRight === "Notes" &&
					<NotesSidebarExtension
						loadingLocalData={this.state.loadingLocalData}
						setLoadingLocalData={(loadingLocalData, callback) => this.setState({ loadingLocalData }, callback && callback)}
						template={this.state.template}
						pinSelected={this.state.pinSelected}
						setPinSelected={(pinId, boolean, callback) => this.setState({ pinSelected: pinId, showPinModal: boolean }, callback && callback)}
						tickers={this.props.data.tickers}
						elementsWithSupercript={this.state.elementsWithSupercript}
						locatedFootnote={this.state.locatedFootnote}
						setLocatedFootnote={(id) => this.setState({ locatedFootnote: id })}
						setShowPinModal={(boolean) => this.setState({ showPinModal: boolean })}
						replaceFootNoteWarning={this.state.replaceFootNoteWarning}
						setReplaceFootNoteWarning={(boolean) => this.setState({ replaceFootNoteWarning: boolean })}
						slideIn={this.state.commentsSlideIn}
						slideOut={this.state.commentsSlideOut}
					/>}
				{this.state.sideBarExtRight === "Versions" &&
					<VersionsSidebarExtension
						slideIn={this.state.commentsSlideIn}
						slideOut={this.state.commentsSlideOut}
						template={this.state.template}
						ticker={this.props.data.ticker}
					/>}
				{/* {this.state.sideBarExtRight === "Model" &&
					<ModelSidebarExtension
						slideIn={this.state.commentsSlideIn}
						slideOut={this.state.commentsSlideOut}
						template={this.state.template}
						ticker={this.props.data.ticker}
					/>} */}
			</>
		);
	}
}

export default withData(withStorage(withRemote(BuilderPage)));